// localStorage persistence for the Studio's "current eye" — the
// reference image + parameter snapshot + description that Studio
// keeps around between reloads so mum doesn't lose her work if she
// refreshes the tab.
//
// Keyed as `stamps:lastEye:v1` so a future schema change can ship as
// `stamps:lastEye:v2` without trampling older sessions.

import type { Parameters } from '../types/parameters';

export interface PersistedEye {
  id: string;
  image_url: string;
  thumbnail_url: string;
  parameters: Parameters;
  parent_id: string | null;
  seed: number | null;
  description: string | null;
  createdAt: number;
}

const KEY = 'stamps:lastEye:v1';

export function loadPersistedEye(): PersistedEye | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedEye;
    if (Date.now() - parsed.createdAt > 24 * 60 * 60 * 1000) return null;
    return parsed;
  } catch {
    return null;
  }
}
export function savePersistedEye(eye: PersistedEye): void {
  try { localStorage.setItem(KEY, JSON.stringify(eye)); } catch { /* quota */ }
}
export function clearPersistedEye(): void {
  try { localStorage.removeItem(KEY); } catch { /* */ }
}